import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "title is-5" }
const _hoisted_4 = { class: "table is-fullwidth" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "has-text-grey"
}
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "list-table-container" }
const _hoisted_10 = { class: "has-text-centered mt-4 mb-4" }
const _hoisted_11 = {
  key: 1,
  class: "has-text-centered"
}
const _hoisted_12 = { class: "is-size-4" }
const _hoisted_13 = {
  class: "modal-card",
  style: {"width":"640px","max-width":"95vw"}
}
const _hoisted_14 = { class: "modal-card-head" }
const _hoisted_15 = { class: "modal-card-title" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "modal-card-body" }
const _hoisted_18 = { class: "modal-card-foot" }
const _hoisted_19 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.details)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_breadcrumb, {
              size: "is-large",
              separator: "has-succeeds-separator",
              "aria-label": "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_breadcrumb_item, {
                  tag: "a",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToList()), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('secrets.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_breadcrumb_item, { active: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('secrets.details')), 1),
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('secrets.name')) + ":", 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.details.name), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('secrets.lastAccessed')) + ":", 1)
                    ]),
                    _createElementVNode("td", null, [
                      (_ctx.details.accessedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$d(new Date(_ctx.details.accessedAt), 'short')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('secrets.created')) + ":", 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(_ctx.details.createdAt), 'short')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('secrets.lastUpdated')) + ":", 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(_ctx.details.updatedAt), 'short')), 1)
                  ])
                ])
              ]),
              _createVNode(_component_b_button, {
                type: "is-primary",
                onClick: _ctx.openUpdateModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('secrets.updateValue')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('secrets.integrationsUsing')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_b_table, {
                  data: _ctx.details.integrations || [],
                  striped: "",
                  onClick: _ctx.handleRowClick,
                  "sort-icon": "menu-up",
                  "default-sort": "name",
                  "default-sort-direction": "asc"
                }, {
                  empty: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('secrets.noIntegrationsUsing')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_b_table_column, {
                      field: "name",
                      sortable: "",
                      label: "Name"
                    }, {
                      default: _withCtx((props) => [
                        _createTextVNode(_toDisplayString(props.row.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_table_column, {
                      field: "id",
                      sortable: "",
                      label: "ID"
                    }, {
                      default: _withCtx((props) => [
                        _createTextVNode(_toDisplayString(props.row.id), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "onClick"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('secrets.notFound')), 1),
            _createVNode(_component_b_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToList())),
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.updateModalOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updateModalOpen) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": false,
      "aria-role": "dialog",
      "can-cancel": ['escape','x','outside'],
      "aria-label": _ctx.$t('secrets.updateValue'),
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("header", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('secrets.updateValue')), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: props.close
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("section", _hoisted_17, [
            _createVNode(_component_b_field, {
              label: _ctx.$t('secrets.value')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_input, {
                  type: "textarea",
                  rows: 6,
                  modelValue: _ctx.newValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newValue) = $event)),
                  placeholder: _ctx.$t('secrets.valuePlaceholder'),
                  maxlength: "100000",
                  required: ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("footer", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_b_button, {
                type: "is-primary",
                disabled: !_ctx.isValid,
                onClick: _ctx.saveNewValue
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_b_button, {
                onClick: props.close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.close')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "aria-label"])
  ], 64))
}